<template>
    <v-select
        class="select-lang"
        :items="languages"
        item-text="title"
        item-value="code"
        v-model="currentLang"
        @change="changeLang"
    />
</template>
<script>
export default {
  name: 'SelectLang',
  data () {
    return {
      currentLang: '',
      languages: [
        { title: 'РУ', code: 'ru' },
        { title: 'КГ', code: 'kg' }
      ]
    }
  },
  mounted () {
    const selectedLang = JSON.parse(window.localStorage.getItem('schoolLang'))
    this.currentLang = selectedLang || 'kg'
    this.$root.$i18n.locale = this.currentLang
  },
  methods: {
    changeLang (lang) {
      window.localStorage.setItem('schoolLang', JSON.stringify(lang))
      this.$router.go(0)
    }
  }
}
</script>
<style lang="scss">
.select-lang {
    max-width: 55px;
    .v-input__slot:before {
        content: none;
    }
}
</style>
